import { makeStyles, tokens } from '@fluentui/react-components';

export const useAccessMessageStyles = makeStyles({
  /** Fills the available space of whatever surface hosts the message. */
  container: {
    display: 'flex',
    flexGrow: 1,
    height: '100%',
    minHeight: '320px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    boxSizing: 'border-box',
  },
  /** Full viewport variant, for pages rendered outside the app shell. */
  fullScreen: {
    height: '100vh',
    backgroundColor: tokens.colorNeutralBackground1,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    maxWidth: '520px',
    textAlign: 'center',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '48px',
    lineHeight: '48px',
    color: tokens.colorNeutralForeground3,
    marginBottom: '8px',
  },
  eyebrow: {
    color: tokens.colorNeutralForeground3,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  title: {
    color: tokens.colorNeutralForeground1,
  },
  body: {
    color: tokens.colorNeutralForeground2,
    lineHeight: '20px',
    textAlign: 'center',
  },
  actions: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginTop: '16px',
  },
});
